export const useDialog = () => {
  const { t } = useI18n();

  const openConfirm = async (
    text: string,
    confirmButtonText: string,
    options?: object
  ) => {
    const { default: Swal } = await import("sweetalert2/dist/sweetalert2");
    const { isConfirmed } = await Swal.fire({
      text: text,
      icon: "question",
      showCancelButton: true,
      cancelButtonText: t("buttons.cancel"),
      confirmButtonText: confirmButtonText || t("buttons.yes"),
      reverseButtons: true,
      heightAuto: false,
      ...options,
    });
    return isConfirmed;
  };

  const openPrompt = async (
    text: string,
    input: "text" | "url",
    confirmButtonText: string,
    options?: object
  ) => {
    const { default: Swal } = await import("sweetalert2/dist/sweetalert2");
    const { value } = await Swal.fire({
      text: text,
      icon: "question",
      input: input,
      showCancelButton: true,
      cancelButtonText: t("buttons.cancel"),
      confirmButtonText: confirmButtonText || t("buttons.yes"),
      reverseButtons: true,
      heightAuto: false,
      ...options,
    });

    return value;
  };

  async function openErrorDialog(
    errorMessage: string | Error = ""
  ): Promise<void> {
    console.error(errorMessage);

    const { default: Swal } = await import("sweetalert2/dist/sweetalert2");
    const result = await Swal.fire({
      title: t("errors.error"),
      text: t("errors.unknownErrorRefresh"),
      icon: "error",
      showCancelButton: true,
      cancelButtonText: t("buttons.cancel"),
      confirmButtonText: t("buttons.reload"),
    });

    if (result.value) {
      window.location.reload();
    }
  }

  return {
    openConfirm,
    openPrompt,
    openErrorDialog,
  };
};
